export default __webpack_public_path__ + "static/media/interior1.2a4c8c44.webp";